import { render, staticRenderFns } from "./infoBase.vue?vue&type=template&id=6d1338f2&scoped=true&"
import script from "./infoBase.vue?vue&type=script&lang=js&"
export * from "./infoBase.vue?vue&type=script&lang=js&"
import style0 from "./infoBase.vue?vue&type=style&index=0&id=6d1338f2&prod&scoped=true&lang=css&"
import style1 from "./infoBase.vue?vue&type=style&index=1&id=6d1338f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1338f2",
  null
  
)

export default component.exports